import { render, staticRenderFns } from "./upload1.vue?vue&type=template&id=86ec7bd6&scoped=true"
import script from "./upload1.vue?vue&type=script&lang=js"
export * from "./upload1.vue?vue&type=script&lang=js"
import style0 from "./upload1.vue?vue&type=style&index=0&id=86ec7bd6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ec7bd6",
  null
  
)

export default component.exports